import PdfPreview from "@/routes/(pdf)/pdf-preview"
import { pdfStore } from "./pdf-store"
import { toast } from "sonner"
import { useState } from "react"
import { useEffect } from "react"
import { useRef } from "react"
import { buildPdf } from "@/apis/pdf-api"
import Wrapper from "@/components/wrapper"

const PdfModal = () => {
  const { open, closeModal, pdfId, info } = pdfStore()
  const [isWorking, setIsWorking] = useState(false)
  const toastId = useRef(null)

  const scale = 0.7

  const action = () => {
    toastId.current = toast.loading("PDF 생성 중...")
    setIsWorking(true)
  }

  useEffect(() => {
    if (!isWorking) return

    const action = async () => {
      const result = await buildPdf(pdfId)
      toast.dismiss(toastId.current)

      const url = window.URL.createObjectURL(new Blob([result]))

      const link = document.createElement("a")
      const downloadedAt = new Date().toISOString().slice(0, 10)
      const fileName =
        info?.apt && info?.dong && info?.ho
          ? `${info.apt} ${info.dong}동 ${info.ho}호 ${downloadedAt}.pdf`
          : "leak_notice.pdf"

      link.href = url
      link.setAttribute("download", fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      setIsWorking(false)
    }
    action()
  }, [isWorking, info.apt, info.dong, info.ho, pdfId])

  if (!open) return null

  return (
    <Wrapper.modal onClose={closeModal} className="px-6 py-6 rounded-xl">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-xl font-semibold">미리보기</h2>

        <div className="flex items-center gap-2">
          <button
            onClick={closeModal}
            className="
              h-9 px-4 rounded-md
              border border-gray-300
              bg-white
              hover:bg-gray-50
              transition cursor-pointer
            "
          >
            닫기
          </button>

          <button
            onClick={action}
            disabled={isWorking}
            className="
              h-9 px-4 rounded-md
              bg-[#041C3F]
              text-white
              hover:opacity-90
              transition
              cursor-pointer
              disabled:opacity-60
              disabled:cursor-wait
            "
          >
            {isWorking ? "생성 중..." : "PDF 다운로드"}
          </button>
        </div>
      </div>

      <div
        className="mx-auto overflow-hidden"
        style={{
          width: `calc(210mm * ${scale})`,
          height: `calc(297mm * ${scale})`
        }}
      >
        <div className="w-[210mm] h-[297mm] origin-top-left" style={{ scale }}>
          <PdfPreview />
        </div>
      </div>
    </Wrapper.modal>
  )
}

export default PdfModal
